import gql from "graphql-tag";

const createHelpdeskCategory = gql`
  mutation(
    $code: String!
    $title: String!
    $description: String
    $processUserIds: [ID!]
    $groupId: ID!
  ) {
    createHelpdeskCategory(
      data: {
        title: $title
        description: $description
        processUserIds: $processUserIds
        code: $code
        groupId: $groupId
      }
    ) {
      id
      title
      code
      groupId
      processUsers {
        id
        username
        fullname
        email
      }
      createdAt
      updatedAt
    }
  }
`;

const createHelpdeskQA = gql`
  mutation($answer: String, $question: String!, $categoryId: ID!) {
    createHelpdeskQA(
      data: { answer: $answer, question: $question, categoryId: $categoryId }
    ) {
      id
      question
      answer
    }
  }
`;

const updateHelpdeskCategory = gql`
  mutation(
    $id: ID!
    $code: String!
    $title: String!
    $description: String
    $processUserIds: [ID!]
    $groupId: ID!
  ) {
    updateHelpdeskCategory(
      id: $id
      data: {
        title: $title
        description: $description
        code: $code
        processUserIds: $processUserIds
        groupId: $groupId
      }
    ) {
      id
      title
      code
      processUsers {
        id
        username
        fullname
        email
      }
      createdAt
      updatedAt
    }
  }
`;

const updateHelpdeskQA = gql`
  mutation($id: ID!, $categoryId: ID, $question: String, $answer: String) {
    updateHelpdeskQA(
      id: $id
      data: { categoryId: $categoryId, question: $question, answer: $answer }
    ) {
      id
      question
      answer
    }
  }
`;

const deleteHelpdeskQA = gql`
  mutation($id: ID!) {
    deleteHelpdeskQA(id: $id) {
      id
    }
  }
`;

const deleteHelpdeskCategory = gql`
  mutation($id: ID!) {
    deleteHelpdeskCategory(id: $id) {
      id
    }
  }
`;

const getListHelpdeskCategory = gql`
  query($limit: Int, $page: Int, $query: String) {
    getListHelpdeskCategory(
      query: $query
      paging: { limit: $limit, page: $page }
    ) {
      id
      title
      code
      processUsers {
        id
        fullname
        username
        email
      }
      groupId
      group {
        id
        name
      }
      createdAt
      updatedAt
      author {
        id
        username
        fullname
      }
    }
  }
`;

const getListHelpdeskQA = gql`
  query($limit: Int, $page: Int, $query: String) {
    getListHelpdeskQA(query: $query, paging: { limit: $limit, page: $page }) {
      id
      answer
      question
    }
  }
`;

const getDetailHelpdeskCategory = gql`
  query($id: ID!) {
    getDetailHelpdeskCategory(id: $id) {
      id
      title
      code
      processUsers {
        id
        fullname
        username
        email
      }
      qas {
        id
        question
        answer
      }
      groupId
      group {
        id
        name
      }
      createdAt
      updatedAt
      author {
        id
        username
        fullname
      }
    }
  }
`;

export default {
  createHelpdeskCategory,
  updateHelpdeskCategory,
  deleteHelpdeskCategory,
  getListHelpdeskCategory,
  getDetailHelpdeskCategory,
  createHelpdeskQA,
  getListHelpdeskQA,
  updateHelpdeskQA,
  deleteHelpdeskQA,
};
